import { createContext, useEffect, useState } from 'react';
import { getData } from '~/helper/apiService';
import useWindowWidth from '~/hooks/useWindowWidth';

const FetchDataContext = createContext();

function FetchDataProvider({ children }) {
  const [posts, setPosts] = useState([]);
  const [tips, setTips] = useState([]);
  const [tipsType, setTipsType] = useState([]);
  const postCount = useWindowWidth();
  const [isCurrentLimit, setIsCurrentLimit] = useState(false);

  useEffect(() => {}, [postCount]);

  const loadPosts = async (isLimit) => {
    let limit = 0;
    if (postCount === 6) {
      limit = 10;
    } else if (postCount === 5) {
      limit = 10;
    } else if (postCount === 4) {
      limit = 8;
    } else if (postCount === 3) {
      limit = 6;
    } else if (postCount === 2) {
      limit = 4;
    } else if (postCount === 1) {
      limit = 2;
    }
    const params = new URLSearchParams();

    if (isLimit) {
      params.append('limit', limit);
      setIsCurrentLimit(true);
    } else if (isCurrentLimit && isLimit === undefined) {
      params.append('limit', limit);
    } else {
      setIsCurrentLimit(false);
    }
    const newPost = await getData(`/post/read?${params.toString()}`);
    setPosts(newPost);
  };

  const loadTips = async (limit) => {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit);
    const newTips = await getData(`/tips/read?${params.toString()}`, null);
    setTips(newTips?.value);
    setTipsType(newTips?.types);
  };

  return (
    <FetchDataContext.Provider value={{ posts, loadPosts, tips, tipsType, loadTips }}>
      {children}
    </FetchDataContext.Provider>
  );
}

export { FetchDataContext, FetchDataProvider };
